// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2ersF","notActive":"styles_notActive__68iWG"};